import {
	PlatformWorkerPromise,
	PlatformWorkerPromiseSym,
	SdkHandlersProvider,
	ServiceProvider,
} from '@wix/thunderbolt-symbols'
import { withDependencies, optional } from '@wix/thunderbolt-ioc'
import {
	NamedSignalsServiceDefinition as definition,
	NamedSignalsService as impl,
	INamedSignalsServiceDefinition,
	INamedSignalsService,
	INamedSignalsServiceConfig,
} from '@wix/thunderbolt-services'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import type { SsrSignalsSdkHandlers } from './types'

export const NamedSignalsServiceClient = withDependencies(
	[optional(PlatformWorkerPromiseSym)],
	(platformWorkerPromiseObj?: {
		platformWorkerPromise: PlatformWorkerPromise
	}): ServiceProvider<
		INamedSignalsServiceDefinition,
		(opts: ServiceFactoryOpts<INamedSignalsServiceConfig>) => INamedSignalsService
	> => {
		const config = {
			onRemoteChange: async (cb: (name: string, value: any) => void) => {
				if (!platformWorkerPromiseObj) {
					return
				}
				const worker = (await platformWorkerPromiseObj.platformWorkerPromise) as Worker
				worker.onmessage = ({ data: message }: any) => {
					if (message.type === 'updateRemote') {
						const { name, value } = message
						cb(name, value)
					}
				}
			},
			updateRemote: async (name: string, value: any) => {
				if (!platformWorkerPromiseObj) {
					return
				}
				const worker = (await platformWorkerPromiseObj.platformWorkerPromise) as Worker
				worker.postMessage({ type: 'updateRemote', name, value })
			},
		}

		return {
			definition,
			impl,
			config,
			hasNonSerializablePlatformConfig: true,
		}
	}
)

export const NamedSignalsServiceServer = withDependencies([], (): ServiceProvider<
	INamedSignalsServiceDefinition,
	(opts: ServiceFactoryOpts<INamedSignalsServiceConfig>) => INamedSignalsService
> &
	SdkHandlersProvider<SsrSignalsSdkHandlers> => {
	const store: Record<string, any> = {}

	const config = {
		onRemoteChange: async () => {},
		updateRemote: async () => {},
	}

	return {
		definition,
		impl,
		config,
		hasNonSerializablePlatformConfig: true,
		platformConfig: { initialStore: store }, // will be used for service init in builder-component isolate

		getSdkHandlers: () => ({
			ssr: {
				updateRemote: (name: string, value: any) => (store[name] = value),
			},
		}),
	}
})
